/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'it',
  homeScreen: {
    title: '',
    stayConnected: 'Resta connesso',
    comingSoon: 'Disponibile a breve',
    downloadNow: 'Scarica subito:',
    readMore: 'Per saperne di più ',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Qualcosa è andato storto. Riprova più tardi.',
    },
    programStatus: {
      title: 'Il Mio Stato',
      loading: 'Caricamento…',
      yourRep: 'Il Tuo Rappresentante',
      myProfile: 'Profilo',
      favorites: 'Preferiti',
      registeredOn: 'Iscritto il:',
      graduatedOn: 'Diplomato il:',
      totalBadgesEarned: 'Totale Distintivi Ottenuti:',
      lastBookingLogged: 'Ultima Prenotazione Registrata:',
      currentTier: 'Livello Attuale',
      lastBadgeEarned: 'Ultimo Distintivo Ottenuto:',
      currentFocus: 'Focus Attuale:',
    },
    todaysfocus: {
      title: 'Focus di Oggi',
      empty: 'Nessun elemento in evidenza per oggi',
      loading: 'Caricamento…',
      error: 'Qualcosa è andato storto',
      slideNavAria: 'Navigazione diapositive',
      slideAria: 'Diapositiva',
      carouselAria: 'Focus di oggi',
    },
    welcome: 'Benvenuto!',
    welcomeBack: 'Bentornato, {firstName}!',
    notifications: {
      loading: 'Caricamento…',
      empty: 'Nessuna notifica',
    },
    achievements: {
      title: 'Premi e Concorsi',
      loading: 'Caricamento…',
      lastBooking: 'Ultimo Invio Voce',
      currentTier: 'Livello Attuale',
      contestEntries: 'Totale Partecipazioni al Concorso',
      nightsBooked: 'Notti Prenotate',
      totalRevenue: 'Ricavi Totali Segnalati',
      noBookingData: 'Nessun dato di prenotazione disponibile.',
      fileUploadSuccess: 'Il file è stato caricato con successo.',
      quickSubmit: {
        title: 'Invio rapido',
        uploading: 'Caricamento…',
        clear: 'Cancella',
        submit: 'Invia',
        submitSuccessSimulated: 'Prenotazione inviata con successo',
      },
    },
  },
  profileImageView: {
    currentImage: 'La tua immagine del profilo attuale:',
    uploadImage: 'Carica la tua immagine del profilo:',
    chooseAFile: 'Scegli un file…',
    cancel: 'annulla',
    backButton: 'Indietro',
    uploadButton: 'Carica immagine del profilo',
    saveButton: 'Salva questa immagine del profilo',
    fileTooLargeTitle: 'Dimensione di caricamento superata',
    fileTooLargeText: "La dimensione massima dell'immagine da caricare è 10 MB",
  },
  notification: {
    newAndNow: 'Nuovo e Ora!',
    alert: 'Avviso',
    message: 'Messaggio',
    badge: 'Nuovo Badge',
    contest: 'Concorso',
    'content-update': 'Aggiornamento Contenuto',
    events: 'Eventi',
    other: 'Notifica',
    welcome: 'Benvenuto',
  },
  sharing: {
    email: 'E-mail',
    download: 'Scarica',
    copyURL: 'Copia collegamento',
    copied: 'Copiato',
    shareSubjectBadge: 'Badge di specialista degli Stati Uniti',
  },
  shareSubjectDiploma: 'Diploma di specialista degli Stati Uniti',
  loginScreen: {
    version2: {
      accountCreated: "È stato creato un account, controllare l'e-mail per completare il processo.",
      homeTitle: 'Vediamo se riusciamo a trovare un profilo già esistente nel nostro sistema.',
      homeTitleSub: "Inserisci l'indirizzo e-mail che usi per accedere agli altri programmi di formazione.",
      noAccount: "Nessun account trovato ({email}). Riprova con un'altra e-mail o crea un nuovo account.",
      continueButton: 'Continua',
      success: 'Account aggiornato correttamente. Sarai reindirizzato a breve alla home page.',
      successNewAccount:
        "Per completare la registrazione, riceverai un'e-mail di conferma per verificare il tuo account.",
      loginButton: 'Accedi',
      matchFound: 'Abbiamo trovato una corrispondenza. Inserisci la tua password per continuare.',
      magicLink: 'Accedi tramite collegamento inviato alla tua e-mail:',
      magicLinkButton: 'Richiedi il collegamento magico',
      magicLinkTitle: 'Ricevi un collegamento diretto nella tua casella di posta per accedere immediatamente.',
      otherEmailButton: 'Invia',
      title:
        'Inserisci tutte le informazioni di seguito, poiché verranno inserite nel tuo profilo personale e nelle informazioni di contatto.',
      titleIndustry:
        'Inserisci tutte le informazioni di seguito, poiché verranno inserite nel tuo profilo personale e nelle informazioni di contatto.',
      register: 'Crea un account',
      agent: 'Consulente di viaggio',
      visitor: 'Visitatore del settore',
      step1: 'Passaggio 1: Tipo di utente',
      step2: 'Passaggio 2: Crea un account',
      step3: 'Passaggio 3: Crea il tuo profilo',
      marketingOptIn: 'Confermi di non voler rimanere collegato al team di agenti di viaggio di questo programma?',
      optIn: 'Sì, voglio rimanere collegato',
      optOut: 'Non voglio rimanere collegato',
      step2Sub1: 'Parlaci di te',
      step2Sub2: 'Parlaci della tua azienda',
      privacyHead: 'PREFERENZE DI COMUNICAZIONE',
      privacySub:
        'Seleziona le caselle di seguito per assicurarti di ricevere comunicazioni importanti dal team di agenti di viaggio del fornitore (aggiornamenti e comunicazioni sui prodotti, premi, incentivi, FAM trip ecc.) nonché iniziative di networking con colleghi e supporto alle vendite da TravPRO Mobile.',
      privacy:
        'Proteggiamo le tue informazioni personali senza venderle, usarle impropriamente o tradire la fiducia che riponi in noi.',
      store: 'Scarica questo programma dal tuo app store in tutta facilità:',
      powered: 'OFFERTO DA',
      toastMessage: {
        forgotSuccess:
          'Abbiamo inviato il collegamento per la reimpostazione della password al tuo indirizzo e-mail. Verrai reindirizzato alla pagina di accesso tra 10 secondi.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
        magicLinkMessage: "Attendi, stiamo effettuando l'accesso.",
        magicLinkError:
          'Impossibile trovare il tuo account nel nostro database. Accedi manualmente. Verrai reindirizzato tra 10 secondi.',
        magicLinkError1:
          "Impossibile trovare un token valido. Accedi o richiedi un nuovo collegamento magico. Se il problema persiste, contattaci all'indirizzo: info@travpromobile.com.",
        magicLinkError2:
          'Impossibile trovare il tuo account nel nostro database. Accedi manualmente. Verrai reindirizzato tra 10 secondi.',
        magicLinkSuccess:
          "Controlla la tua e-mail all'indirizzo {email}. Troverai un collegamento magico tramite il quale potrai effettuare l'accesso.",
        magicLinkErrorWait: 'Attendi 5 minuti prima di richiedere un nuovo collegamento magico.',
        emailNotFoundError:
          "Non abbiamo trovato l'indirizzo e-mail inserito nei nostri record. Verifica eventuali errori ortografici o crea un nuovo account.",
      },
      errors: {
        zipCodeNotFound: 'CAP non trovato, riprova',
        zipCodeOnlyNumbers: 'Il campo CAP può contenere solo numeri',
        password: 'Inserisci una password',
        passwordNotMatching: 'Le password inserite non corrispondono',
        passwordTooShort: 'La password deve avere una lunghezza minima di 8 caratteri',
        emailExists:
          'Questo indirizzo e-mail esiste già o non è valido. Inserisci un altro indirizzo e-mail o accedi al tuo account.',
        fillInAllFields: 'Compila tutti i campi obbligatori',
        fillInEmail: 'Inserisci il tuo indirizzo e-mail.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
      },
      fields: {
        forgotSubCopy: 'Hai dimenticato la password e vuoi modificarla? ',
        forgotSubCopy2:
          "Vuoi evitare di dover inserire la password? Ti invieremo un'e-mail con un collegamento magico che ti consentirà di accedere direttamente al programma. ",
        city: 'Città',
        companyName: 'Nome azienda',
        role: 'Il tuo ruolo (selezionane uno)',
        description: "Quale delle seguenti opzioni descrive meglio l'attività della tua azienda?",
        country: 'Paese',
        password: 'Password',
        passwordRegister: 'Scegli una password (minimo 8 caratteri)',
        passwordConfirm: 'Conferma password',
        firstName: 'Nome',
        lastName: 'Cognome',
        agency: 'Nome agenzia',
        title: 'Il tuo ruolo (selezionane uno)',
        company: 'Nome azienda',
        select: 'Seleziona una delle opzioni di seguito',
        state: 'Stato',
        province: 'Provincia/regione/Stato',
        zipCode: 'CAP',
        postalCode: 'Codice postale',
        affiliate: 'Qual è il gruppo di affiliazione PRINCIPALE della tua agenzia?',
        hostAgency: "Qual è l'agenzia ospitante?",
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Vendite',
        coordinator: 'Coordinamento',
        opt: 'Rimani in contatto con il team di Brand USA e ricevi gli aggiornamenti del programma USA Discovery',
        optMarketing:
          'Rimani in contatto con TravPRO per ricevere informazioni su ulteriori programmi di apprendimento',
        retail: 'Front desk del punto vendita',
        home: 'Agente freelance',
        independent: 'Agente indipendente',
        host: 'Agenzia ospitante',
        call: 'Call Center o agenzia basata sul Web',
        other: 'Altro ',
        describes: "Quale delle seguenti opzioni descrive meglio te e l'attività della tua agenzia? ",
      },
    },
    title: 'Programma di formazione per professionisti del settore viaggi e programma di abilitazione alla vendita',
    welcome: {
      headerTop: 'Ti diamo il benvenuto a',
      headerBottom: 'USA Discovery Program',
    },
    sellingPoints: {
      0: 'Impara, promuovi e vendi in movimento',
      1: 'Formazione multimediale su più dispositivi',
      2: 'Certificato di fine corso',
      3: 'Badge partner ed esperienze',
      4: 'Materiali promozionali condivisibili',
      5: 'Risorse di vendita 24 ore al giorno, 7 giorni alla settimana',
      6: 'Premi per la formazione',
      7: 'Incentivi e MegaFam tour',
    },
    tAndC: {
      agree: 'Continuando, accetti la nostra ',
      privacyPolicy: 'informativa sulla privacy',
      and: ' e ',
      termsConditions: 'i nostri termini e condizioni',
    },
    fields: {
      select: 'Seleziona una delle opzioni di seguito',
      country: 'Paese',
      agency: 'Agenzia',
      email: 'E-mail',
      password: 'Password',
      passwordConfirm: 'Conferma la password',
      firstName: 'Nome',
      lastName: 'Cognome',
      address: 'Indirizzo',
      postalCode: 'CAP',
      city: 'Città',
      agencyName: "Nome dell'agenzia",
      stateProvince: 'Stato/provincia',
      required: 'Obbligatorio',
      invalidEmail: 'Indirizzo e-mail non valido',
      opt: 'Resta in contatto! Sì, voglio ricevere comunicazioni da Brand USA per tenermi aggiornato su notizie, eventi, incentivi, FAM trip e molto altro!',
      forgot:
        "Hai dimenticato la password? Fai clic sul pulsante qui sotto per richiedere un'e-mail per la reimpostazione della password.",
    },
    forgot: 'Reimposta password',
    noAgent: {
      noAgentButton: 'Non sono un agente',
      title: "Grazie per l'interesse mostrato per USA Discovery Program.",
      messageWeb:
        'Il contenuto di questo sito è riservato esclusivamente ai professionisti del settore viaggi. \n Per ulteriori informazioni su Brand USA, visita: ',
      messageMobile:
        'Alcuni contenuti di questa applicazione sono riservati esclusivamente ai professionisti del settore viaggi. Per un\'anteprima dei contenuti dell\'app, premi "Continua".',
      continue: 'Continua',
      visitWebsite: 'Visita il sito Web',
    },
    newUser: 'Nuovo utente',
    register: 'Registrati',
    registered: 'Questa e-mail è già registrata',
  },
  welcomeScreen: {
    title: 'Ti diamo il benvenuto a USA Discovery Program',
    helloUser: 'Ciao {{name}}',
    hello: 'Ciao,',
    fromAgency: 'da {{agency}}',
    notUser: 'Non sei {{name}}?',
    startTraining: 'Inizia la tua formazione',
    continueTraining: 'Continua la tua formazione',
    graduated: 'Congratulazioni!',
    downloader: {
      stop: 'interrompi',
      init: 'Inizializzazione in corso…',
      lastUpdate: 'Ultimo aggiornamento: ',
    },
  },
  trainingScreens: {
    comingSoon: 'Disponibile a breve: {title}',
    categoryLockMinimum: 'Sblocca almeno {number} formazioni incluse per accedere a questa categoria.',
    allUnlocked: 'Hai sbloccato tutti i capitoli!',
    completedBase: 'Congratulazioni, ora sei uno specialista certificato degli Stati Uniti!',
    certificate: 'Certificato',
    chapter: 'Capitolo',
    chapterComplete: 'Capitolo completato!',
    choose: 'Scegli una risposta',
    confirm: 'Conferma la risposta',
    continue: 'Continua',
    courseComplete: 'Corso completato!',
    durationInMinutes: '{number} minuti',
    endReached: 'Hai raggiunto la fine',
    essential: 'Base',
    essentialSub:
      'Completa questi capitoli di base per conseguire il diploma e accedere alle specializzazioni riportate di seguito.',
    message: '{count} messaggio',
    messagePlural: '{count} messaggi',
    percentageComplete: '{number}% completo',
    restart: 'Ripasso',
    review: 'Ripasso',
    retainEnd:
      "Utilizza la barra superiore per spostarti all'interno di questo capitolo o premi il pulsante indietro per tornare alla panoramica.",
    retry: 'Riprova',
    skip: 'Indietro >',
    viewAllTitle: 'Suggerimento per la formazione',
    badge: 'Scarica badge',
    viewAll:
      'Prima di passare alla pagina successiva, dedica qualche minuto al ripasso di tutti i contenuti qui presenti, incluse le icone, che ti offrono informazioni aggiuntive utili per aiutarti a diventare uno specialista.',
    start: 'Inizia',
    status: 'Stato attuale:',
    trouble: 'Sembra che tu sia in difficoltà. Rileggi il contenuto delle pagine precedenti e riprova.',
    unlockDefault: 'Sblocca questo capitolo completando quello precedente.',
    unlock: 'Sblocca questo capitolo completando il capitolo di formazione.',
    unlockSubtitle: 'Sblocca altri capitoli completando i capitoli di formazione.',
    unlockFoundation: 'Sblocca questi capitoli completando Base.',
    watchListenRead: 'Guarda, ascolta e leggi di più',
    completed: 'Completato',
  },
  trainingExtraScreens: {
    subtitle: 'LE ESPERIENZE',
    error: 'Ci dispiace. Si è verificato un errore',
    uncompletedTitle: 'ESPERIENZE {partner} NON COMPLETATE',
    completedTitle: 'ESPERIENZE {partner} COMPLETATE',
    noAvailableBadges: 'Al momento non sono ancora disponibili badge.',
    interimScore: 'Completa',
    interimScoreEnd: 'altri capitoli per ottenere il tuo badge.',
    badgesComplete: 'Congratulazioni! Hai guadagnato il badge:',
  },
  newTrainingFlow: {
    partnerModules: 'SPECIALIZZAZIONI DEI PARTNER',
    finishGold: 'Scopri i nostri partner e ottieni badge completando questi capitoli.',
  },
  points: {
    complete: {
      chapter: 'Capitolo completato!',
      'intro-chapter': 'Capitolo introduttivo completato!',
      'sub-app': 'SubApp completata!',
      rewards: 'Premi completati!',
    },
    completed: 'Badge ottenuti {completed}',
  },
  nav: {
    home: 'Home',
    train: 'Formazione',
    learn: 'Formazione',
    retain: 'Retain',
    promote: 'Promuovi',
    sell: 'Vendi',
    info: 'Info',
    rewards: 'Premi',
    media: 'File multimediali',
    favorites: 'Preferiti',
    contact: 'Contattaci',
    diploma: 'Diploma',
    accountSettings: 'Impostazioni account',
    messages: 'Messaggi',
    search: 'Cerca',
    showcases: 'Vetrine',
  },
  contentHeaders: {
    subapps: 'SPECIALIZZAZIONI DEI PARTNER',
    maintrainings: 'Sedi',
    subtrainings: 'Le esperienze',
    itineraries: 'ITINERARI',
  },
  pageDescriptions: {
    train: 'Apprendi, divertiti e diventa un esperto.',
    retain: 'Memorizza le tue conoscenze specialistiche con questa risorsa di contenuto facile da usare.',
    promote:
      'Condividi questi elementi per suscitare interesse e avviare una conversazione con clienti e potenziali clienti.',
    sell: 'Rispondi alle domande dei clienti e interagisci con Brand USA.',
    favorites: 'I tuoi contenuti preferiti.',
    search: 'Sfoglia tutti i contenuti',
    subapps: 'Scopri i nostri partner e ottieni badge completando questi capitoli.',
    subtrainings: 'Perfeziona la tua esperienza e ottieni un badge per ogni sezione riportata di seguito.',
    itineraries: 'Completa questi brevi capitoli sui viaggi on the road più popolari e ottieni un badge per ciascuno di essi.',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: 'Password dimenticata?',
    next: 'Successivo',
    yes: 'Sì',
    no: 'No',
    previous: 'Precedente',
    submit: 'Invia',
    register: 'Registrati',
    back: 'Indietro',
    close: 'Chiudi',
    page: 'Pagina',
    search: 'Cerca',
    logIn: 'Accedi',
    logOut: 'Disconnettiti',
    viewItem: 'Visualizza {type}',
    imageNotFound: 'Immagine non trovata',
    noResultsFor: 'Nessun risultato trovato per: {{query}}',
    noFavorites: 'Non hai ancora aggiunto elementi ai preferiti.',
    noMessages: 'Non hai ancora ricevuto messaggi.',
    resultsFor: 'Risultati per: {{query}}',
    showAll: 'Mostra tutto',
    connectionError: 'Errore di connessione',
    alreadyExists: 'Esiste già',
    pageNotFound: 'Errore 404: pagina non trovata!',
    oops: 'Oh-oh!',
    overview: 'Torna alla panoramica',
    complete: 'Continua',
    courseComplete: 'Capitolo completato!',
    chapterComplete: 'Capitolo completato!',
    message: 'Messaggio ({count})',
    messagePlural: 'Messaggi ({count})',
  },
  itemTypes: {
    image: 'Immagine',
    brochure: 'Raccolta',
    layout: 'Layout',
    web: 'Sito Web',
    pdf: 'PDF',
    carousel: 'Raccolta',
  },
  questions: {
    dials: 'Ruota i quadranti per dare la risposta corretta',
    fitb: 'Compila gli spazi vuoti',
    flip: 'Modifica il numero per dare la risposta corretta',
    multipleChoice: 'Scegli la o le risposte giuste',
    slider: 'Scegli la risposta corretta utilizzando il cursore',
    map: 'Rispondi alla domanda toccando la posizione corretta sulla mappa',
    dropdown: 'Scegli...',
    true: 'Vero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Scarica',
    email: 'E-mail',
    print: 'Stampa',
  },
  cookies: {
    consent: "D'ACCORDO",
    optout: 'Rifiuto esplicito',
    settings: 'Impostazioni privacy',
    message:
      "Non ci hai comunicato le tue preferenze sulla privacy dei dati. Va bene, ma vorremmo offrirti la migliore esperienza con l'Assistente vendite.",
    disabled: "Sembra che tu abbia disattivato l'uso dei cookie.",
    use: "{{appName}} richiede l'uso dei cookie per offrire la migliore esperienza possibile.",
    details: 'A cosa servono i cookie?',
    enable: 'Scopri come attivare i cookie {{here}}.',
    here: 'qui',
  },
  notLoggedIn: {
    super: "Non hai effettuato l'accesso",
    title: "Devi aver effettuato l'accesso per visualizzare questo contenuto",
    guest: 'Ospite',
  },
  demo: {
    message:
      'Questo sito Web è una demo del prodotto finale. Attualmente è in fase di sviluppo e non è un prodotto completo.',
    consent: 'Capito!',
  },
  share: {
    header: 'Condividi questa risorsa sui tuoi social media preferiti!',
    download: 'Scarica',
    email: 'E-mail',
  },
  breadCrumbs: {
    page: 'Pagina',
  },
  storeButtons: {
    title: "Scarica l'app sul tuo dispositivo mobile",
  },
  onMobile: {
    header: "Sembra che tu stia tentando di accedere all'app {appName} da un dispositivo mobile",
    body: "Per scaricare questo programma, visita l'app store e cerca {appName} oppure fai clic su uno dei pulsanti riportati di seguito",
    benefits: {
      1: 'Impara, promuovi e vendi in movimento',
      2: 'Formazione multimediale su più dispositivi',
      3: 'Certificato di fine corso',
      4: 'Badge partner ed esperienze',
      5: 'Materiali promozionali condivisibili',
      6: 'Risorse di vendita 24 ore al giorno, 7 giorni alla settimana',
      7: 'Premi per la formazione',
      header: 'In questo modo otterrai:',
    },
  },
  custom: {
    splitUsers: 'Sono...',
    brandAmbassador: 'Brand ambassador',
    travelPro: 'Professionista del settore viaggi',
  },
  rewards: {
    menu: {
      home: 'Home\nRicompense',
      achievements: 'Risultati\nFormazione',
      bookings: 'Incentivi\nBadge',
      form: 'Invia\nPrenotazioni',
    },
    rewards: 'Premi',
    title: 'Ti diamo il benvenuto nel Centro premi e risultati',
    subheader: 'Monitora e condividi i risultati e gli incentivi della formazione',
    button: 'Invia la tua prenotazione',
    viewAllBookings: 'Prenotazioni',
    viewDashboard: 'Dashboard punti',
    viewRewards: 'Panoramica',
    overview: {
      valid: '*Le prenotazioni inserite sono valide solo dopo il completamento del viaggio del cliente.',
    },
    home: {
      entries: 'Voci attuali',
      trainingAchievements: 'RISULTATI DELLA FORMAZIONE',
      trainingAchievementsText:
        'Tieni traccia dei tuoi progressi, delle certificazioni e dello stato dei premi da questa pagina. Potrai scaricare e condividere il tuo diploma di specialista degli Stati Uniti, così come tutti i badge che hai guadagnato in Esperienze e Specializzazioni dei partner.',
      bookingContests: 'DASHBOARD INCENTIVI',
      bookingContestsText:
        'Monitora e gestisci i programmi di incentivi attuali in tutta facilità dalla Dashboard incentivi. ',
      submitBooking: 'INVIA LE PRENOTAZIONI',
      submitBookingText:
        'Da questa pagina potrai inviare le prenotazioni per includerle in Incentivi per le prenotazioni.',
      currentContest: 'INCENTIVI ATTUALI',
      noContests: 'Attualmente non sono presenti Incentivi per i badge.',
      ContestEndDate: 'Termine incentivo:',
      ContestDetails: 'Dettagli incentivo',
      ContestSeeProgram: 'Consulta il programma',
      ContestTerms: 'Termini e condizioni',
      ContestForDetails: 'per i dettagli.',
      ContestPartnerLink: 'Vai a Partner',
      ContestLink: 'Vai a Collegamento',
    },
    bookingsView: {
      title: 'Prenotazioni',
      infoMessage:
        "Ordinare utilizzando i pulsanti in alto e fare clic su qualsiasi record per gestire i dettagli dell'invio. Tutte le iscrizioni in sospeso saranno verificate entro 72 ore",
    },
    leaderboardScreen: {
      prizes: 'Premi',
      tAndC: 'Offerta soggetta a termini e condizioni*',
    },
    dashboardView: {
      title: 'Dashboard incentivi',
      subtitle: 'Tieni traccia delle tue attività relative agli incentivi da questa pagina.',
      badge: 'Incentivi per i badge',
      activity: 'Incentivi per le prenotazioni',
      manage: 'Gestisci prenotazioni',
      manageSub: 'Seguite le prenotazioni attuali qui sotto, oppure visualizzate le prenotazioni archiviate utilizzando il menu a tendina.',
      noBadgeIncentives: 'Attualmente non sono presenti Incentivi per i badge.',
      noBookings: 'Nessun record da visualizzare.',
      state: {
        approvedEntries: 'Voci Approvate',
        pendingEntries: 'Iscrizioni in Sospeso',
        declinedEntries: 'Voci Rifiutate',
        viewAll: 'Visualizza Tutti',
      },
      currentYear: 'Anno Corrente',
      archivedBookings: 'Prenotazioni Archiviate',
    },
    bookingForm: {
      title: 'Modulo crediti prenotazioni Stati Uniti',
      subTitle: 'Inserisci la tua prenotazione:',
      required: '* Indica un campo obbligatorio',
      email: 'E-mail consulente',
      agentFirstName: 'Nome consulente',
      agentLastName: 'Cognome consulente',
      company: 'Nome agenzia/azienda',
      iata: 'N. IATA/CLIA',
      stateProvince: 'Stato/provincia',
      postalCode: 'Codice postale',
      country: 'Paese',
      city: 'Città',
      birthday: 'Compleanno',
      type: 'Tipo di viaggio ospite',
      source: 'Origine prenotazione',
      tourOperator: 'Tour operator',
      firstName: 'Nome ospite',
      lastName: 'Cognome ospite',
      confirmNumber: 'Numero di conferma della prenotazione/numero PNR',
      ticketNumber: 'Numero del biglietto.',
      file: 'Caricamento prova RezSnap™ ',
      arrivalDate: 'Data di arrivo nella sistemazione',
      departureDate: 'Data di partenza dalla sistemazione',
      brand: 'Marchio prenotato',
      lengthOfStay: 'Durata del soggiorno',
      cost: 'Costo totale della prenotazione',
      rooms: 'Numero di camere',
      airline: 'Compagnia aerea/vettore (codice a 2 cifre)',
      gateway: 'Aeroporto di origine (codice aeroportuale di 3 lettere)',
      destination: 'Destinazione/isola (codice aeroportuale di 3 lettere)',
      disclaimer: '* Campi obbligatori',
      button: 'Invia la tua prenotazione',
      sub: 'Informazioni personali',
      sub2: 'Informazioni sulla prenotazione',
      travelDepartureDate: 'Data di partenza',
      travelReturnDate: 'Data di ritorno',
      flightNumber: 'Numero del volo con destinazione USA',
      numberOfTravelers: 'Numero di viaggiatori nel gruppo',
      edit: 'Modifica le tue informazioni',
      fileUploaded: 'Il file è stato caricato correttamente',
      select: "Selezionare un'opzione di seguito",
      drag: 'Trascinare e rilasciare un file qui, oppure fare clic per selezionare un file.',
      fileType: '(Saranno accettati file .jpeg, .png e .pdf. La dimensione massima del file è di 100 MB.)',
      maxSize: 'La dimensione massima del file è 100 MB',
    },
    TermsAndConditions: {
      title: 'i nostri termini e condizioni',
      subTitle: 'Premi trimestrali per gli specialisti',
      body1:
        "Ogni prenotazione pubblicata deve essere accompagnata da una prova di vendita a saldo zero corrispondente a ogni singola prenotazione pubblicata. I vincitori dei premi verranno selezionati in base alla totalità delle prove di vendita verificate corrispondenti a ciascuna prenotazione elencata. Per l'idoneità, le pubblicazioni devono essere conformi a tutte le regole di USA Discovery Program.",
      body2:
        'Per essere idonei, è necessario risiedere negli Stati Uniti o Brand USA ed essere maggiorenni nello stato, nella provincia o nel territorio di residenza. I dipendenti del tour operator NON sono idonei per i sorteggi e NON verranno considerati per i premi aggiuntivi. I residenti della provincia del Quebec NON sono idonei per i sorteggi e NON verranno considerati per i premi aggiuntivi.',
      body3:
        "Per ricevere il premio può essere richiesta la prova dell'accreditamento come consulente di viaggio di agenzia/a domicilio. I premi disponibili sono soggetti a modifiche durante il corso del programma.",
      body4: 'Privacy e utilizzo delle informazioni personali',
      body5:
        "Gli agenti partecipanti (i) garantiscono all'Assegnatario dei premi il diritto di utilizzare il proprio nome, città, stato, provincia, codice postale, conferma di maggiore età, numero di telefono e indirizzo e-mail per includere, a titolo esemplificativo e non esaustivo, i contatti e l'annuncio sui Vincitori e la fornitura dei premi; (ii) concede al Vincitore il diritto di utilizzare le proprie informazioni personali per scopi pubblicitari e promozionali relativi ai premi, su tutti i canali attualmente conosciuti o ideati in seguito, senza ulteriori compensi, salvo che ciò sia vietato dalla legge; e (III) riconosce che gli Assegnatari possono divulgare le proprie informazioni personali ad agenti e fornitori di servizi terzi in relazione a una delle attività elencate ai punti (i) e (II) di cui sopra.",
      button: 'Torna alla pagina di destinazione',
    },
    thankYouPage: {
      thanks: 'Grazie',
      congrats: 'Congratulazioni, ',
      body: 'abbiamo ricevuto la tua prenotazione, che è stata inviata al supervisore della campagna per la verifica.',
      link: 'Ricorda che per essere eletti vincitori è necessario aver completato il programma Base di USA Discovery Program',
    },
  },
  facts: {
    title: 'Lo sapevi?',
  },
  badgeView: {
    other: 'Partner Regionali',
    unlock: 'Inizia a completare gli elementi di formazione per ricevere distintivi',
    title: 'Risultati di Formazione',
    subtitle:
      'Benvenuto nella tua bacheca dei Risultati, dove puoi visualizzare, monitorare e scaricare il tuo diploma e i badge di specializzazione.',
    viewBadge: 'Visualizza Stato',
    badgeDisplayTitle: 'STATO DELLE RICOMPENSE METALLICHE',
    badgeAchievement:
      "Hai raggiunto lo Stato {rank}! Clicca sull'icona a destra per visualizzare e condividere il tuo stato.",
    badgesCompleteTitle: 'I tuoi badge di specializzazione',
    badgesCompleteSubtitle: 'Clicca sulle icone per visualizzare, salvare e condividere i tuoi badge.',
    badgesIncompleteSubtitle: 'Ottieni altri badge completando questi capitoli.',
    bronze: 'Bronzo',
    silver: 'Argento',
    gold: 'Oro',
    platinum: 'Platino',
    diploma: 'Diploma',
    experiencesBadgesSectionTitle: 'I badge delle Esperienze',
    itinerariesBadgesSectionTitle: 'Badge degli itinerari',
    partnerSpecializationBadgesSectionTitle: 'Badge di specializzazione partner',
    complete: 'COMPLETATO',
  },
  missing: {
    discover: 'Scoprire',
    pacific: 'Pacifico',
    west: 'Ovest',
    southwest: 'Sud-Ovest',
    midwest: 'Midwest',
    south: 'Sud-Est',
    northeast: 'Nord-Est',
    territories: 'Territori',
    shoppingAttractions: 'Shopping e Attrazioni',
    gettingAround: 'Spostarsi',
    regionalPartners: 'Partner Regionali',
    greatOutdoors: 'Grandi Spazi Aperti',
    winterSports: 'Sport Invernali',
    coastalEscapes: 'Fughe Costiere',
    flyDrive: 'Fly-Drive',
    foodDrink: 'Cibo e Bevande',
    luxury: 'Lusso',
    musicCultureHeritage: 'Musica, Cultura e Patrimonio',
    nationalParks: 'Parchi Nazionali',
    regionMap: 'Mappa della Regione',
    videos: 'Video',
    images: 'Immagini',
    incentives: 'Incentivi',
    southeast: 'Sud-Est',
  },
  searchModal: {
    search: 'Cerca',
    subtitle: 'Cerca in tutti i contenuti',
    pages: 'USA Discovery Program',
    partnerPages: 'Programmi Partner',
    salesCompanion: 'Elementi del Sales Companion',
    exhibitionTiles: 'Vetrine Partner',
    noResults: 'Nessun risultato trovato...',
  },
};
